import { useTranslation } from "react-i18next";

export default function useTranslatewrapper() {
  const { t: translate, i18n } = useTranslation();
  const language = i18n["language"]
  return {translate, language };
  // return {translate}
}
